import React, { useCallback } from 'react'
import styles from './Header.module.scss'
import LogoSvg from '@/assets/icons/logo-w-title.svg'
import Button, { EButtonType } from '@/components/Button/Button'
import Container from '@/components/Container/Container'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '@/store/store'
import cx from 'classnames'
import Link from 'next/link'
import { useScrollPosition } from 'hooks/useScrollPosition'
import modalSlice from '@/store/reducers/modal'
import { Box, Drawer, IconButton, MenuItem } from '@mui/material'
import BurgerIcon from '@/assets/icons/burger.svg'

const Header = () => {
  const scrollPos = useScrollPosition()
  const { headerAppear } = useSelector((state: RootState) => state.global)
  const dispatch = useDispatch<AppDispatch>()

  const handleClickBtn = useCallback(() => {
    dispatch(modalSlice.actions.toggleOpen(true))
  }, [dispatch])

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div
      className={cx(styles.header, {
        [styles.background]: scrollPos > 0,
        [styles.show]: headerAppear || scrollPos > 0,
      })}
    >
      <Container>
        <div className={cx(styles.inner)}>
          <Link href="/">
            <div className={styles.logo}>
              <LogoSvg className={styles.icon}></LogoSvg>
              {/* <p className={styles.lazy}>Lazy</p> */}
            </div>
          </Link>
          <div style={{ paddingLeft: '90px' }}>
            <Link href="/">
              <p className={cx(styles.lazy)}>Capture</p>
            </Link>
            <Link href="/ai">
              <p className={cx(styles.lazy)}>AI</p>
            </Link>
            <Link href="/pricing">
              <p className={cx(styles.lazy)}>Pricing</p>
            </Link>
          </div>
          <div>
            <Link href="https://vip.lazy.so">
              <p className={styles.lazy}>Log in</p>
            </Link>
            <Button type={EButtonType.icon} text="Get Lazy" onClick={handleClickBtn}></Button>
            <Box className={styles.mobileMenu}>
              <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={anchorEl ? 'long-menu' : undefined}
                aria-expanded={anchorEl ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
              >
                <BurgerIcon width={24} height={24} fill="#b5b6ba" />
              </IconButton>
              <Drawer
                anchor="right"
                open={Boolean(anchorEl)}
                onClose={handleClose}
                className={styles.drawer}
                sx={{
                  zIndex: 5100,
                  '& .MuiDrawer-paper': {
                    backgroundColor: 'rgb(39 39 39 / 94%)',
                    width: '50% !important',
                    zIndex: 1000,
                    justifyContent: 'center',
                    gap: '80px',
                  },
                }}
              >
                <Link href="https://vip.lazy.so">
                  <MenuItem>
                    <p className={cx(styles.lazy)}>Log In</p>
                  </MenuItem>
                </Link>
                <Link href="/">
                  <MenuItem>
                    <p className={cx(styles.lazy)}>Capture</p>
                  </MenuItem>
                </Link>
                <Link href="/ai">
                  <p className={cx(styles.lazy)}>AI</p>
                </Link>
                <Link href="/pricing">
                  <MenuItem>
                    <p className={cx(styles.lazy)}>Pricing</p>
                  </MenuItem>
                </Link>
              </Drawer>
            </Box>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default Header
